import { Component, OnInit } from '@angular/core';
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";

@Component({
  selector: 'app-concrete-layers',
  templateUrl: './concrete-layers.component.html',
  styleUrls: ['./concrete-layers.component.scss']
})
export class ConcreteLayersComponent implements OnInit {

  public isConcreteVisible = false;
  public isConcreteLoaded = false;

  constructor(private adapter: CesiumAdapterService) { }

  ngOnInit() {
    let self = this;
    this.adapter.OSMLoaded.subscribe((result)=>{
      if (result) this.isConcreteVisible = !this.adapter.OSMBuildings.show;
      else { this.isConcreteVisible = false; self.visibleChanged(this.isConcreteVisible);}
    });

    this.adapter.adapterInitialized.subscribe((isInit)=>{
      if (isInit){
        self.adapter.initConcretes().then(()=>{
            self.visibleChanged(this.isConcreteVisible);
            this.isConcreteLoaded = true;
        })
      }
    })
  }

  public visibleChanged(value){
    this.isConcreteVisible = value;
    this.adapter.changeOSMBuildingsVisible(!value);
  }

}
